export default __webpack_public_path__ + "static/media/start.87dc87f8.gif";